let forgotPasswordEmailModal = document.getElementsByClassName(
    'forgot-password__email-modal'
  )[0],
  forgotPasswordEmailModalClose = document.getElementsByClassName(
    'forgot-password__close-button'
  )[0];

if (forgotPasswordEmailModal) {
  forgotPasswordEmailModalClose.addEventListener('click', e => {
    forgotPasswordEmailModal.classList.add('hide');
  });
}
